import { render, staticRenderFns } from "./52.vue?vue&type=template&id=58847984&scoped=true&"
var script = {}
import style0 from "./52.vue?vue&type=style&index=0&id=58847984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58847984",
  null
  
)

export default component.exports